// src/config.ts
var lazyMetaGroupJoiner = ";";
var lazyMetaItemJoiner = ",";
var lazyMetaSubItemJoiner = ":";
var PropertyFlags = /* @__PURE__ */ ((PropertyFlags2) => {
  PropertyFlags2[PropertyFlags2["ATTRIBUTE"] = 1] = "ATTRIBUTE";
  PropertyFlags2[PropertyFlags2["REFLECT"] = 2] = "REFLECT";
  PropertyFlags2[PropertyFlags2["BOOLEAN"] = 4] = "BOOLEAN";
  PropertyFlags2[PropertyFlags2["NUMBER"] = 8] = "NUMBER";
  PropertyFlags2[PropertyFlags2["STATE"] = 16] = "STATE";
  PropertyFlags2[PropertyFlags2["READ_ONLY"] = 32] = "READ_ONLY";
  PropertyFlags2[PropertyFlags2["NO_ACCESSOR"] = 64] = "NO_ACCESSOR";
  return PropertyFlags2;
})(PropertyFlags || {});

export {
  lazyMetaGroupJoiner,
  lazyMetaItemJoiner,
  lazyMetaSubItemJoiner,
  PropertyFlags
};
